import { render, staticRenderFns } from "./otp-validate.vue?vue&type=template&id=a1a1a222&scoped=true&"
import script from "./otp-validate.vue?vue&type=script&lang=ts&"
export * from "./otp-validate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a1a222",
  null
  
)

export default component.exports